export const messages = {
  en: {
    reportPayFeeDetail: {
      search: {
        title: 'Search Conditions',
        startTime: 'Please select payment start time',
        endTime: 'Please select payment end time',
        paymentMethod: 'Please select payment method',
        feeStatus: 'Please select fee status',
        roomOrCarNum: 'Room number or license plate number',
        feeType: 'Please select fee type',
        feeItem: 'Please select fee item',
        feeStartTime: 'Please select fee start time',
        feeEndTime: 'Please select fee end time',
        community: 'Please select community'
      },
      table: {
        title: 'Payment Details',
        tooltip: 'All house payment records details',
        orderNum: 'Order Number',
        roomOwner: 'Room/Owner',
        feeTypeItem: 'Fee Type > Fee Item',
        feeStatus: 'Fee Status',
        paymentMethod: 'Payment Method',
        paymentPeriod: 'Payment Period',
        paymentTime: 'Payment Time',
        cashier: 'Cashier',
        payableAmount: 'Payable/Receivable Amount(Yuan)',
        receivedAmount: 'Received Amount(Yuan)',
        withholdAmount: 'Account Deduction(Yuan)',
        preferentialAmount: 'Preferential/Deduction Amount(Yuan)',
        giftAmount: 'Gift Amount(Yuan)',
        lateFee: 'Late Fee(Yuan)',
        area: 'Area(sqm)',
        parkingSpace: 'Parking Space',
        remark: 'Remark'
      },
      summary: {
        subtotal: 'Subtotal',
        total: 'Total',
        receivable: 'Receivable',
        received: 'Received',
        preferential: 'Preferential',
        deduction: 'Deduction',
        gift: 'Gift',
        lateFee: 'Late Fee',
        yuan: 'Yuan'
      },
      explanation: {
        preferential: 'Preferential amount: preferential amount generated under discount rules and no arrears discount rules',
        deduction: 'Deduction amount: deduction amount generated under deduction rules',
        gift: 'Gift amount: the payable amount of the gifted month under the gift rules',
        lateFee: 'Late fee: the default late fee generated under the default late fee rules, which needs to be paid additionally'
      },
      hide: 'Hide',
      more: 'More',
      fetchError: 'Failed to fetch payment details',
      exportError: 'Failed to export data',
      dateError: 'Payment end time must be greater than payment start time'
    }
  },
  zh: {
    reportPayFeeDetail: {
      search: {
        title: '查询条件',
        startTime: '请选择缴费开始时间',
        endTime: '请选择缴费结束时间',
        paymentMethod: '请选择支付方式',
        feeStatus: '请选择费用状态',
        roomOrCarNum: '房屋编号或者车牌号',
        feeType: '请选择费用类型',
        feeItem: '请选择收费项',
        feeStartTime: '请选择收费开始时间',
        feeEndTime: '请选择收费结束时间',
        community: '请选择小区'
      },
      table: {
        title: '缴费明细表',
        tooltip: '所有房屋缴费记录明细',
        orderNum: '订单号',
        roomOwner: '房号/业主',
        feeTypeItem: '费用类型>费用项',
        feeStatus: '费用状态',
        paymentMethod: '支付方式',
        paymentPeriod: '缴费时间段',
        paymentTime: '缴费时间',
        cashier: '收银员',
        payableAmount: '应缴/应收金额(元)',
        receivedAmount: '实收金额(元)',
        withholdAmount: '账户抵扣(元)',
        preferentialAmount: '优惠/减免金额(元)',
        giftAmount: '赠送金额(元)',
        lateFee: '滞纳金(元)',
        area: '面积(平方米)',
        parkingSpace: '车位',
        remark: '说明'
      },
      summary: {
        subtotal: '小计',
        total: '大计',
        receivable: '应收',
        received: '实收',
        preferential: '优惠',
        deduction: '减免',
        gift: '赠送',
        lateFee: '滞纳金',
        yuan: '元'
      },
      explanation: {
        preferential: '优惠金额：打折规则和打折无欠费规则下产生的优惠金额',
        deduction: '减免金额：减免规则下产生的减免金额',
        gift: '赠送金额：赠送规则下赠送月份应缴的金额',
        lateFee: '滞纳金：违约滞纳金规则下产生的违约金额，需额外缴纳的滞纳金'
      },
      hide: '隐藏',
      more: '更多',
      fetchError: '获取缴费明细失败',
      exportError: '导出数据失败',
      dateError: '缴费结束时间必须大于缴费开始时间'
    }
  }
}